// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1J2_b","inner":"Form_inner__2UHVp","range":"Form_range__1MyAE","name":"Form_name__2adIN","actions":"Form_actions__1FuoV"};